import qs from 'qs'
import * as axiosHelper from './api_helper'

export async function getOrders(params) {
  const result = await axiosHelper.get(`/orders?${qs.stringify(params)}`)
  return result
} 

// export const postOrderAPI = async (params) => {
//   let reqParams = {}
//   console.log("reqParamsreqParams", reqParams, params);
//   if (params.orderType === 'market') {
//     if (params.type === 'buy') {
//       reqParams = {
//         symbol: params.market.pairName,
//         type: params.orderType,
//         side: params.type,
//         amount: `${params.baseAmount}`,
//       }
//     } else if (params.type === 'sell') {
//       reqParams = {
//         symbol: params.market.pairName,
//         type: params.orderType,
//         side: params.type,
//         amount: `${params.baseAmount}`,
//       }
//     }
//   } else if (params.orderType === 'limit') {
//     if (params.type === 'buy') {
//       reqParams = {
//         symbol: params.market.pairName,
//         type: params.orderType,
//         side: params.type,
//         amount: `${params.baseAmount}`,
//         price: params.quoteAmount,
//       }
//     } else if (params.type === 'sell') {
//       reqParams = {
//         symbol: params.market.pairName,
//         type: params.orderType,
//         side: params.type,
//         amount: `${params.baseAmount}`,
//         price: params.quoteAmount,
//       }
//     }
//   } else if (params.orderType === 'conditional') {
//     if (params.type === 'buy') {
//       reqParams = {
//         symbol: params.market.pairName,
//         type: params.orderType,
//         side: params.type,
//         amount: `${params.baseAmount}`,
//         price: params.price,
//         triggerPrice: params.triggerPrice,
//         tpType: params.tpType,
//       }
//     } else if (params.type === 'sell') {
//       reqParams = {
//         symbol: params.market.pairName,
//         type: params.orderType,
//         side: params.type,
//         amount: `${params.baseAmount}`,
//         price: params.price,
//         triggerPrice: params.triggerPrice,
//         tpType: params.tpType,
//       }
//     }
//   } else if (params.orderType === 'oco') {
//     if (params.type === 'buy') {
//       reqParams = {
//         symbol: params.market.pairName,
//         type: params.orderType,
//         side: params.type,
//         amount: `${params.baseAmount}`,
//         tpTriggerPrice: params.tpTriggerPx,
//         tpOrderType: params.tpType,
//         tpPrice: params.tpPrice,
//         slTriggerPrice: params.slTriggerPx,
//         slOrderType: params.slType,
//         slPrice: params.slPrice,
//       }
//     } else if (params.type === 'sell') {
//       reqParams = {
//         symbol: params.market.pairName,
//         type: params.orderType,
//         side: params.type,
//         amount: `${params.baseAmount}`,
//         tpTriggerPrice: params.tpTriggerPx,
//         tpOrderType: params.tpType,
//         tpPrice: params.tpPrice,
//         slTriggerPrice: params.slTriggerPx,
//         slOrderType: params.slType,
//         slPrice: params.slPrice,
//       }
//     }
//   } else if (params.orderType === 'post-only') {
//     reqParams = {
//       symbol: params.market.pairName,
//       type: 'post-only',  // This will be mapped to limit-maker in the backend
//       side: params.type,
//       amount: `${params.baseAmount}`,
//       price: params.quoteAmount,
//     }
//   } else if (params.orderType === 'triggerorder') {
//     reqParams = {
//       symbol: params.market.pairName,
//       type: 'triggerorder',
//       side: params.type,
//       amount: `${params.baseAmount}`,
//       triggerPrice: params?.triggerPrice,
//       // If this is a trigger-limit order
//       ...(params?.triggerOrderType === 'Limit' && {
//         price: params.price,
//       }),
//       orderType: params?.triggerOrderType?.toLowerCase(), // 'limit' or 'market'
//     }
//   }
//   const result = await axiosHelper.post('orders', reqParams)
//   if (result.status) {
//     return result
//   } else throw new Error(result.message)
// }

export const postOrderAPI = async (params, totp) => {
  let reqParams = {}
  // console.log("params.orderType", params);
  // Basic market/limit orders
  if (params.orderType === 'market') {
    reqParams = {
      symbol: params.market.pairName,
      type: params.orderType,
      side: params.type,
      amount: `${params.baseAmount}`,
    }
  } else if (params.orderType === 'limit') {
    reqParams = {
      symbol: params.market.pairName,
      type: params.orderType,
      side: params.type,
      amount: `${params.baseAmount}`,
      price: params.quoteAmount,
    }
  } 
  // Conditional orders (existing implementation)
  else if (params.orderType === 'conditional') {
    reqParams = {
      symbol: params.market.pairName,
      type: params.orderType,
      side: params.type,
      amount: `${params.baseAmount}`,
      price: params.price,
      triggerPrice: params.triggerPrice,
      tpType: params.tpType,
    }
  } 
  // OCO orders (One-Cancels-Other)
  else if (params.orderType === 'oco') {
    reqParams = {
      symbol: params.market.pairName,
      type: params.orderType,
      side: params.type,
      amount: `${params.baseAmount}`,
      tpTriggerPrice: params.tpTriggerPx,
      tpOrderType: params.tpType,
      tpPrice: params.tpPrice,
      slTriggerPrice: params.slTriggerPx,
      slOrderType: params.slType,
      slPrice: params.slPrice,
    }
  } 
  // Post-only orders
  else if (params.orderType === 'post-only') {
    reqParams = {
      symbol: params.market.pairName,
      type: 'post-only',  // This will be mapped to limit-maker in the backend
      side: params.type,
      amount: `${params.baseAmount}`,
      price: params.quoteAmount,
    }
  }
  // Trigger orders (new implementation)
  else if (params.orderType === 'triggerorder') {
    reqParams = {
      symbol: params.market.pairName,
      type: 'trigger',
      side: params.type,
      amount: `${params.baseAmount}`,
      price: params.price,
      triggerPrice: params.triggerPrice,
      tpType: params.tpType, // 'Limit' or 'Market'
    }
    
    // Only include price for Limit trigger orders
    if (params.tpType === 'Limit') {
      reqParams.price = params.price;
    }
  }
  
  console.log("reqParamsreqParams", reqParams, params);
  const result = await axiosHelper.post('orders', reqParams, {
    headers: {
      '2fa-token': totp,
    }
  })
  if (result.status) {
    return result
  } else throw new Error(result.message)
}

// export async function cancelOrderAPI({ orderId, symbol }) {
//   console.log("symbolsymbolsymbol", orderId, symbol)
//   const result = await axiosHelper.post(`/htx/order/${orderId}/cancel?symbol=${symbol}`)
//   if (result.status) {
//     return result
//   } else throw new Error(result.message)
// }
export async function cancelOrderAPI({ orderId }) {
  const result = await axiosHelper.del(`/orders/${orderId}`);
  if (result.status) {
    return result;
  } else throw new Error(result.message);
}